import dayjs from "../RosterDayJS";
import { Roster, Shift } from "./api";

export interface RosterGridRow {
    id: string,
    role: string,
    department: string,
    day1?: Shift[],
    day2?: Shift[],
    day3?: Shift[],
    day4?: Shift[],
    day5?: Shift[],
    day6?: Shift[],
    day7?: Shift[]
}

export function rosterGridRows(roster: Roster, startDate?: Date) {
    const rows: RosterGridRow[] = [];

    if (!roster) {
        return  rows;
    }

    const calculateStartDate = (roster: Roster): dayjs.Dayjs => {
        let firstDate: dayjs.Dayjs = dayjs(Object.keys(Object.entries(roster)[0][1])[0]);
        return firstDate.startOf('isoWeek');
    }
    const startDateJs = startDate
        ? dayjs(startDate)
        : calculateStartDate(roster);

    type Pivot = Map<string, Map<string, RosterGridRow>>;
    const pivot: Pivot = new Map();

    for (let [deptName, days] of Object.entries(roster)) {
        let positionsPivot = pivot.get(deptName);

        if (!positionsPivot) {
            positionsPivot = new Map();
            pivot.set(deptName, positionsPivot);
        }

        for (let [dayName, positions] of Object.entries(days)) {
            const day = dayjs(dayName);

            for (let [positionName, shifts] of Object.entries(positions)) {
                let row = positionsPivot.get(positionName);

                if (!row) {
                    row = {
                        id: deptName + "_" + positionName,
                        department: deptName,
                        role: positionName
                    };

                    positionsPivot.set(positionName, row);
                    rows.push(row);
                }

                switch (day.diff(startDateJs, 'd')) {
                    case 0: row.day1 = shifts; break;
                    case 1: row.day2 = shifts; break;
                    case 2: row.day3 = shifts; break;
                    case 3: row.day4 = shifts; break;
                    case 4: row.day5 = shifts; break;
                    case 5: row.day6 = shifts; break;
                    case 6: row.day7 = shifts; break;
                }
            }
        }
    }

    return rows;
}